namespace RioERP.Masters {
    export interface WhatsAppTemplateVariablesRow {
        Id?: number;
        VariableCode?: string;
        VariableName?: string;
    }

    export namespace WhatsAppTemplateVariablesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'VariableCode';
        export const localTextPrefix = 'Masters.WhatsAppTemplateVariables';
        export const lookupKey = 'Masters.WhatsAppTemplateVariables';

        export function getLookup(): Q.Lookup<WhatsAppTemplateVariablesRow> {
            return Q.getLookup<WhatsAppTemplateVariablesRow>('Masters.WhatsAppTemplateVariables');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            VariableCode = "VariableCode",
            VariableName = "VariableName"
        }
    }
}
